import apiClient from './config';

const authApi = {
  // Login user
  login: async (credentials) => {
    try {
      const response = await apiClient.post('/account/login', credentials);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Register customer
  registerCustomer: async (userData) => {
    try {
      const response = await apiClient.post('/register-customer', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Logout user
  logout: async () => {
    try {
      await apiClient.post('/auth/logout');
      localStorage.removeItem('authToken');
    } catch (error) {
      throw error;
    }
  },

  // Get current user profile
  getProfile: async () => {
    try {
      const response = await apiClient.get('/auth/profile');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Change password (first time or regular)
  changePassword: async (passwordData) => {
    try {
      const response = await apiClient.post('/account/change-password', passwordData, 
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default authApi; 